import { createQuery } from 'react-query-kit'
import Debug from 'debug'

import type { GetPathParams } from '@jotta/grpc-js-client/files/getPath'
import { getPath } from '@jotta/grpc-js-client/files/getPath'
const debug = Debug('jotta:files:useFileDownloadLinkContent')

/**
 * Fetch download link as text
 * For fetching uploaded text documents
 * Returns empty string if
 */
export const useFileDownloadLinkContentQueryKey = [
  'FileDownloadLinkContent',
] as const
export const useFileDownloadLinkContent = createQuery<
  string,
  Pick<GetPathParams, 'path' | 'includeDeleted' | 'token'>
>({
  queryKey: useFileDownloadLinkContentQueryKey,
  fetcher: async params => {
    try {
      const { item } = await getPath({
        ...params,
        includeThumb: false,
        includeChildren: false,
        includeDownloadLinks: true,
      })
      const { downloadLink } = item
      if (!downloadLink) {
        return ''
      }
      const res = await fetch(downloadLink)
      const content = await res.text()
      return content
    } catch (error) {
      debug('Fetch failed', error)
      return ''
    }
  },
})
